var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-3",attrs:{"height":"100%"}},[_c('apexchart',{attrs:{"type":"pie","height":"360","options":_vm.chart.gender.options,"series":_vm.chart.gender.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }